const routes = [
  {
    path: "/crm",
    name: "crm",
    component: () => import(/* webpackChunkName: "crm" */ "../views/crm/index.vue"),
    meta: { section_name: "crm" },
  },
  {
    path: "/crm/contacts",
    name: "crm-contacts",
    component: () => import(/* webpackChunkName: "crm-contacts" */ "../views/crm/contacts.vue"),
    meta: { section_name: "crm" },
  },
  {
    path: "/crm/contact/create",
    name: "crm-contact-create",
    component: () => import(/* webpackChunkName: "crm-contact-create" */ "../views/crm/contact-create.vue"),
    meta: { section_name: "crm" },
  },
  {
    path: "/crm/opportunities",
    name: "crm-opportunities",
    component: () => import(/* webpackChunkName: "crm-opportunities" */ "../views/crm/opportunities.vue"),
    meta: { section_name: "crm" },
  },
  {
    path: "/crm/opportunity/create",
    name: "crm-opportunity-create",
    component: () => import(/* webpackChunkName: "crm-opportunity-create" */ "../views/crm/opportunity-create.vue"),
    meta: { section_name: "crm" },
  },
];
export default routes;
